import { render, staticRenderFns } from "./PiPortfolioDetails.vue?vue&type=template&id=3f6384a7&scoped=true"
import script from "./PiPortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PiPortfolioDetails.vue?vue&type=script&lang=js"
import style0 from "./PiPortfolioDetails.vue?vue&type=style&index=0&id=3f6384a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6384a7",
  null
  
)

export default component.exports